import { Injectable } from '@angular/core';
import { observable, action } from 'mobx-angular';
import { TranslateService } from '@ngx-translate/core';
import { AppConfigStore } from './app-config.store';
import { Storage } from '@ionic/storage-angular';
import { LangService } from '../services';

@Injectable()
export class UiStore {
    @observable isRTL = false;
    @observable currentLang: string = '';
    @observable currentPlan: string = '';
    @observable defaultUnit: string = '';
    @observable detoxData: any = {}
    @observable displayLangs: any = []

    constructor(
        private appConfigStore: AppConfigStore,
        private translate: TranslateService,
        private storage: Storage,
        private langService: LangService,
    ) {
        storage.create();

        // storage.get('defaultLang').then((val) => {
        //     this.setLang(val || appConfigStore.appConfig.defaultLang);
        // });
        // storage.get('defaultUnit').then((val) => {
        //     this.defaultUnit = val || this.defaultUnit;
        // });
        // storage.get('currentPlan').then((val) => {
        //     this.currentPlan = val || appConfigStore.appConfig.defaultPlan;
        // });

        // "defaultLang": "en",
        // "defaultPlan": "standard"

        // this language will be used as a fallback when a translation isn't found in the current language
        // translate.setDefaultLang('en');

        // the lang to use, if the lang isn't available, it will use the current loader to get them
        // translate.use('en');
    }

    @action
    setLang(lang) {
        console.log(lang);
        this.currentLang = lang;
        this.storage.set('defaultLang', lang);
        this.langService.setLangTranslation(lang);
        this.translate.use(lang);
        this.translate.setDefaultLang(lang);
        console.log('Use: ', lang);
        if (lang === 'he') {
            this.isRTL = true;
        } else {
            this.isRTL = false;
        }

    }

    @action
    setCurrent(key: string, value: string) {
        this[key] = value;
        this.storage.set(key, value);
    }

    @action
    setDetoxData(data) {
        this.detoxData = data
    }

    @action
    setDisplayLangs(displayLangs) {
        this.displayLangs = displayLangs
    }


}
